
import {
  defineComponent, unref, ref, reactive, computed,
} from 'vue';

import {
  ConfigProvider,
  message,
  Input,
  Table,
  Row,
  Col,
  Form,
  Modal as AModal,
  Tree,
  Upload,
} from 'ant-design-vue';
import { ColumnProps, } from 'ant-design-vue/es/table/interface';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import { useStore, } from 'vuex';

import { serverIp, } from '@/configs/index';

import { selectUserList, selectTreeList, insertNotice, } from '../sendNotice';

const { Item, } = Form;
const { TextArea, } = Input;

export default defineComponent({
  components: {
    Form,
    AModal,
    Item,
    Row,
    Col,
    Input,
    TextArea,
    Upload,
    Tree,
    Table,
  },
  setup (props, { emit, }) {
    interface listType {
      id: string,
      compony: string,
      children?: Array<any>,
      [propertys: string]: any,
    }
    interface FormState {
      name: string | undefined;
      tel: string | undefined;
    }
    type Key = ColumnProps['key'];
    const imgList = ref<any>([]);
    const textFileList = ref<any>([]);
    const previewImage = ref<any>(null);
    const previewVisible = ref<boolean>(false);
    const list = ref<any>([]);
    // 选中树的节点
    const selectedTreeKeys = ref<any[]>([]);
    // 选中的row的序号（针对当前列表）
    const selectedRowKeys = ref<Key[]>([]);
    const selectedRows = ref<any>([]);
    const selectedRowsObj = ref<any>({});
    // 展开节点
    const expandData = ref<any[]>([]);
    // 搜索下拉所有内容
    const searchList = ref<any>([]);
    // 表单
    const formRef = ref();

    const formState = reactive<any>({
      title: '',
      describetion: '',
      person: '',
    });
    const rules = {
      title: [
        {
          required: true,
          message: '请输入标题',
          trigger: 'blur',
          whitespace: true,
        },
      ],
      describetion: [
        {
          required: true,
          message: '请输入工单描述',
          trigger: 'blur',
          whitespace: true,
        },
        {
          min: 2,
          max: 2000,
          message: '长度需控制在2-2000',
          trigger: 'blur',
        },
      ],
    };

    type ColumnType = {
      title: string;
      align?: string,
      dataIndex?: string;
      slots?: any;
      width?: any;
      ellipsis?: boolean;
      customRender?: any;
    };

    // 列表行配置
    const columns: ColumnType[] = [
      {
        title: '序号',
        align: 'center',
        customRender: (item: any) => `${item.index + 1}`,
        width: '20%',
      },
      {
        title: '用户名',
        dataIndex: 'name',
        width: '35%',
        ellipsis: true,
      },
      {
        title: '组织',
        dataIndex: 'company',
        width: '45%',
        ellipsis: true,
      },
    ];

    // 表格数据
    const tableData = ref<any>([]);
    const streetTiltle = (val:any) => `选中${val.length}人`;

    const store = useStore();

    store.dispatch('userCenter/getOriFramework');

    const loadUserTable = (companyId: any): void => {
      const params = {
        companyId,
        // eslint-disable-next-line multiline-comment-style
        pageNo: 1,
        pageSize: 999,
        // "ALL查询本级及以下" "不传查询本级"
        type: 'ALL',
      };

      selectUserList(params).then((res: any) => {
        if (res && res.code === '200') {
          tableData.value = res.pageList.list.filter((i: any) => i.isValid === '1');
          selectedRowKeys.value = [];
          tableData.value.forEach((item: any, index: number) => {
            if (selectedRows.value.find((i: any) => i.id === item.id)) {
              selectedRowKeys.value.push(index);
            }
          });
        }
      });
    };

    const handleSelect = (s: string[], e: any): void => {
      loadUserTable(selectedTreeKeys.value[0]);
    };

    const getBase64 = (file: any) => new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

    const handlePreview = async (file: any) => {
      let preview: any = null;

      if (!file.url && !file.preview) {
        // eslint-disable-next-line require-atomic-updates
        preview = await getBase64(file.originFileObj);
      }
      previewImage.value = file.url || preview;
      previewVisible.value = true;
    };

    const handleImgChange = (file: any) => {
      const { file: curFile, fileList: curFileList, } = file;
      const maxSize = 1024 * 1024 * 5;

      if (curFile.size < maxSize && imgList.value.length < 9) {
        imgList.value = curFileList;
      }
    };

    const beforeImgUpload = (file: any) => {
      const maxSize = 1024 * 1024 * 5;

      if (file.size > maxSize || file.size === maxSize) {
        message.warning('请上传5MB以内的图片');

        return false;
      }

      if (imgList.value.length > 8) {
        message.warning('仅支持上传9个文件');

        return false;
      }
    };

    const handleImgRemove = (file: any) => {
      const index = imgList.value.findIndex((item: any) => item.uid === file.uid);

      imgList.value.splice(index, 1);
    };

    const handleTextChange = (file: any) => {
      if (textFileList.value.length < 10) {
        textFileList.value = file.fileList;
      }
    };

    const beforeTextUpload = (file: any) => {
      if (textFileList.value.length > 9) {
        message.warning('仅支持上传10个文件');

        return false;
      }
    };

    const handleTextRemove = (file: any) => {
      const index = textFileList.value.findIndex((item: any) => item.uid === file.uid);

      textFileList.value.splice(index, 1);
    };

    const backToList = () => {
      emit('backToList');
    };

    const dealFlat = (data: listType, parent: any = []): Array<any> => {
      const temp: Array<any> = [];

      data.forEach((item: any) => {
        temp.push({
          key: item.id,
          value: item.company,
          level: item.level,
          parent: [item.parentCompany, ...parent,],
        });

        if (item.children) {
          temp.push(dealFlat(item.children, [item.parentCompany, ...parent,]));
        }
      });

      return temp;
    };

    const dealChildren = (data: listType): Array<any> => {
      const temp: Array<any> = [];

      data.forEach((item: any) => {
        temp.push(item.children ?
          {
            key: item.id,
            title: item.company,
            ...item,
            children: dealChildren(item.children),
          } :
          {
            key: item.id,
            title: item.company,
            ...item,
          });
      });

      return temp;
    };

    const loadTreeList = (): void => {
      selectTreeList().then((res: any) => {
        if (res && res.code === '200') {
          list.value = dealChildren(res.treeList);
          searchList.value = dealFlat(res.treeList).flat(Infinity);
        }
      });
    };

    const resetForm = () => {
      selectedRows.value = [];
      selectedRowsObj.value = {};
      selectedRowKeys.value = [];
      imgList.value = [];
      textFileList.value = [];
      formRef.value.resetFields();
    };

    const sendNotice = (): void => {
      formRef.value.validate()
        .then(() => {
          const userId = selectedRows.value.map((item: any) => item.id);
          const userName = selectedRows.value.map((item: any) => item.name);

          if (!selectedRows.value || !selectedRows.value.length) {
            return message.warning('请选择发送对象');
          }
          const params = {
            title: formState.title,
            content: formState.describetion,
            picPath: imgList.value
              .map((cur: any) => cur.response.data)
              .join(','),
            annexPath: textFileList.value
              .map((cur: any) => cur.response.data)
              .join(','),
            annexName: textFileList.value
              .map((cur: any) => cur.name)
              .join(','),
            userId: userId.join(','),
            userName: userName.join(','),
          };

          insertNotice(params).then((res: any) => {
            backToList();
            resetForm();
          });
        });
    };

    const delPerson = (index: number, company: string, name: any): void => {
      selectedRowsObj.value[company].splice(index, 1);
      if (selectedRowsObj.value[company].length === 0) {
        Reflect.deleteProperty(selectedRowsObj.value, company);
      }
      const curIndex = selectedRows.value.findIndex((item: any) => item.company === company && item.name === name);

      selectedRows.value.splice(curIndex, 1);

      selectedRowKeys.value = [];

      tableData.value.forEach((item: any, i: number) => {
        if (selectedRows.value.find((j: any) => j.id === item.id)) {
          selectedRowKeys.value.push(i);
        }
      });
    };

    const rowSelection = computed(() => ({
      selectedRowKeys: unref(selectedRowKeys),
      onSelect: (record:any,selected:boolean,rows:any[]) => {
        selectedRowsObj.value = {};
        if (selected) {
          selectedRows.value.push(record);
        } else {
          const idx = selectedRows.value.findIndex((item: any) => item.userId === record.userId);

          if (idx > -1) {
            selectedRows.value.splice(idx, 1);
          }
        }

        selectedRows.value.forEach((item: any) => {
          Reflect.set(selectedRowsObj.value, item.company, []);
        });
        selectedRows.value.forEach((item: any) => {
          selectedRowsObj.value[item.company].push(item.name);
        });
      },
      onSelectAll: (selected:boolean,rows:any[],changeRaws:any[]) => {
        selectedRowsObj.value = {};
        if (selected) {
          selectedRows.value.push(...changeRaws);
        } else {
          changeRaws.forEach((record:any) => {
            const idx = selectedRows.value.findIndex((item: any) => item.userId === record.userId);

            if (idx > -1) {
              selectedRows.value.splice(idx, 1);
            }
          });
        }

        selectedRows.value.forEach((item: any) => {
          Reflect.set(selectedRowsObj.value, item.company, []);
        });
        selectedRows.value.forEach((item: any) => {
          selectedRowsObj.value[item.company].push(item.name);
        });
      },
      onChange: (keys: Key[], rows: any[]) => {
        selectedRowKeys.value = keys;
      },
    }));

    loadUserTable('');
    loadTreeList();

    return {
      formRef,
      formState,
      rules,
      imgList,
      textFileList,
      previewVisible,
      previewImage,
      serverIp,
      list,
      selectedTreeKeys,
      selectedRowsObj,
      expandData,
      zhCN,
      columns,
      tableData,
      rowSelection,
      sendNotice,
      delPerson,
      streetTiltle,
      handlePreview,
      handleImgChange,
      beforeImgUpload,
      handleImgRemove,
      beforeTextUpload,
      handleTextChange,
      handleTextRemove,
      backToList,
      handleSelect,
      resetForm,
    };
  },
});
